import { render, staticRenderFns } from "./fallback-filters.vue?vue&type=template&id=3c627b7d&"
import script from "./fallback-filters.vue?vue&type=script&lang=ts&"
export * from "./fallback-filters.vue?vue&type=script&lang=ts&"
import style0 from "./fallback-filters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports